import { CommonModule } from '@angular/common'
import { Component, signal, ChangeDetectionStrategy } from '@angular/core'
import { ClientNotification } from '@baboor/client-ui'
import { ClientBottomNavComponent } from '../../../client-ui/client-bottom-nav/client-bottom-nav.component'
import { ClientNotificationDrawerComponent } from '../../../client-ui/client-notification-drawer/client-notification-drawer.component'
import { HeaderClientDefaultComponent } from '../../../headers/components/header-client-default/header-client-default.component'
import { SidebarClientComponent } from '../../../sidebars/components/sidebar-client/sidebar-client.component'

@Component({
    selector: 'app-layout-client-default',
    imports: [
        CommonModule,
        HeaderClientDefaultComponent,
        SidebarClientComponent,
        ClientBottomNavComponent,
        ClientNotificationDrawerComponent,
    ],
    templateUrl: './layout-client-default.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './layout-client-default.component.css',
})
export class LayoutClientDefaultComponent {
    isSidebarCollapsed = signal(false)
    isMobileSidebarOpen = false
    showNotifications = signal(false)
    notificationCount = signal(2)

    notifications = signal<ClientNotification[]>([
        {
            id: '1',
            type: 'confirmation',
            title: 'Appointment Confirmed',
            message:
                'Your haircut with John at StyleBarber is confirmed for tomorrow at 2:00 PM.',
            createdAt: new Date().toISOString(),
            read: false,
        },
        {
            id: '2',
            type: 'appointment_reminder',
            title: 'Reminder: Appointment in 2 hours',
            message:
                "Don't forget your appointment at StyleBarber with Sarah at 4:30 PM.",
            createdAt: new Date(Date.now() - 86400000).toISOString(),
            read: false,
        },
        {
            id: '3',
            type: 'promotion',
            title: 'Special Offer at Urban Cuts',
            message: 'Get 20% off on all hair styling services this weekend!',
            createdAt: new Date(Date.now() - 172800000).toISOString(),
            read: true,
        },
    ])

    toggleSidebar() {
        if (window.innerWidth <= 768) {
            this.isMobileSidebarOpen = !this.isMobileSidebarOpen
        } else {
            this.isSidebarCollapsed.update((v) => !v)
        }
    }

    closeMobileSidebar() {
        this.isMobileSidebarOpen = false
    }

    toggleNotifications() {
        this.showNotifications.update((v) => !v)
    }

    closeNotifications() {
        this.showNotifications.set(false)
    }
}
